export default "__VITE_ASSET__efAlmzyJ__"